import React, { useRef, useState, useMemo  } from "react";
import JsBarcode from "jsbarcode";
import { useReactToPrint } from "react-to-print";
import { connect } from "react-redux";

const PrintStyles = () => (
  <style>
    {`
      @media print {
        html, body {
          width: 5cm;
          height: 3cm;
        }      
        body {
          margin: 0;
          padding: 0;
        }
        svg {
          width: 5cm;
          height: 3cm;
        }
        div.barcode-container {
          width: 5cm;
          height: 3cm;
          display: flex;
          align-items: center;
          justify-content: center;
          page-break-after: always;
        }
      }
    `}
  </style>
);

function BarcodePrint(props) {
  const [heading, setHeading] = useState("");
  const [initial, setInitial] = useState("");
  const [startNumber, setStartNumber] = useState(1000);
  const [barcodeCount, setBarcodeCount] = useState(10);

  const printRef = useRef(null);

  const handlePrint = useReactToPrint({
    contentRef: printRef, // ✅ new syntax for v3.x
    documentTitle: "Barcodes",
  });

  // const barcodeValues = Array(10).fill("123456789012");
  const barcodeValues = useMemo(() => {
    const values = [];
    for (let i = 0; i < barcodeCount; i++) {
      values.push(`${initial}${startNumber + i}`);
    }
    return values;
  }, [initial, startNumber, barcodeCount]);


  const BarcodeList = ({ heading, codes, printRef }) => {
    return (
      <div ref={printRef}>
        {codes.map((code, index) => (
          <div key={index} className="barcode-container">
            <div style={{ textAlign: "center", fontSize: "14px", marginBottom: "4px" }}>
              {heading}
            </div>
            <Barcode value={code} />
          </div>
        ))}
      </div>
    );
  };

  const Barcode = ({ value, width = 2, height = 60 }) => {
    const containerRef = useRef();

    React.useEffect(() => {
      if (!containerRef.current) return;

      // Clean up old barcode
      containerRef.current.innerHTML = "";

      // Create extensible SVG
      const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");

      JsBarcode(svg, value, {
        format: "CODE128",
        width,
        height,
        displayValue: true,
      });

      containerRef.current.appendChild(svg);
    }, [value, width, height]);

    return <div ref={containerRef} />;
  };

  return (
    <div style={{ padding: "20px" }}>
      <PrintStyles />
      {/* External Button */}
      <input type="text" placeholder="Enter Top line (Heading)" onChange={e => setHeading(e.target.value)} style={{margin: "4px"}}/>
      <input type="text" placeholder="Enter Initial" onChange={e => setInitial(e.target.value)}  style={{margin: "4px"}}/>
      <input type="number" placeholder="Enter Starting Barcode Value" name="startNumber" id="startNumber" onChange={e => setStartNumber(Number(e.target.value))}  style={{margin: "4px"}}/>
      <input type="number" placeholder="Enter Number of Barcodes" name="barcodeCount" id="barcodeCount" onChange={e => setBarcodeCount(Number(e.target.value))}  style={{margin: "4px"}}/>
      <button className="btn btn-primary" onClick={handlePrint}  style={{margin: "4px"}}>Print Barcodes</button>

      <BarcodeList heading={heading} codes={barcodeValues} printRef={printRef} />

    </div>
  );
}
export default connect()(BarcodePrint);